import type { ReactNode } from 'react';

export interface PillTabsOption<T extends string> {
  value: T;
  /** Aceita JSX para permitir bolinhas/ícones de estado antes do texto. */
  label: ReactNode;
  count?: number;
}

interface PillTabsProps<T extends string> {
  value: T;
  options: PillTabsOption<T>[];
  onChange: (next: T) => void;
}

/** Abas-pílula genéricas (DS). A aba ativa fica em destaque; contador opcional. */
export function PillTabs<T extends string>({ value, options, onChange }: PillTabsProps<T>) {
  return (
    <div className="inline-flex p-1 rounded-full bg-muted/60 gap-1">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => onChange(o.value)}
          className={`px-3 py-1 rounded-full text-xs font-semibold transition-colors inline-flex items-center gap-1.5 ${
            value === o.value
              ? 'bg-card text-foreground shadow-sm'
              : 'text-muted-foreground hover:text-foreground'
          }`}
        >
          {o.label}
          {o.count !== undefined && o.count > 0 && (
            <span className="text-[10px] font-mono opacity-70">{o.count}</span>
          )}
        </button>
      ))}
    </div>
  );
}
